(function($){

	$.fn.buttonStartLoading = function() {
		return this.each(function()
		{
			var $btn = $(this);
			$btn.width($btn.width());
			$btn.height($btn.height());
			$btn.data("original-html", $btn.html());
			var sLoadingText = $btn.data("loading-text");
			if(empty(sLoadingText)) sLoadingText = 'Загружаю…'
			$btn.html('\
			    <span class="spinner-grow spinner-grow-sm"\
			          role="status" aria-hidden="true">\
			    </span>') // &nbsp;'+sLoadingText)
				.toggleClass('disabled', true)
				.attr('disabled', 'disabled')
				;
		});
	};

	$.fn.buttonStopLoading = function() {
		return this.each(function()
		{
			// _TODO: вообще по-хорошему надо возвращать назад обнлуять width и height, если их ранее не было. Но потом.
			var $btn = $(this);
			$btn.html($btn.data("original-html"))
				.toggleClass('disabled', false)
				.attr('disabled', '0')
				.removeAttr('disabled')
				;
		});
	};


})(jQuery);
